import { createFileRoute } from '@tanstack/react-router'

import { InvoiceDetailPage } from '@/pages/invoices/[id]/InvoiceDetailPage'

export const Route = createFileRoute('/_authenticated/_dashboard/invoices/$id/')({
  component: InvoiceDetailPage,
})
